import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "modal__desc" }, " Если есть какие-то вопросы, или если тобой были замечены какие-то несостыковки в цифрах: ", -1)
const _hoisted_2 = { class: "modal__contacts" }
const _hoisted_3 = { class: "modal__contact" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "@ullus77", -1)
const _hoisted_5 = { class: "modal__contact modal__link" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://forum.enlisted.net/ru/u/Ullus/",
  target: "_blank"
}, "forum.enlisted.net/ru/u/Ullus/", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "modal__desc" }, " Дискорд предпочтительнее, т.к. форум посещаю редко. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconDiscord = _resolveComponent("IconDiscord")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconLetter = _resolveComponent("IconLetter")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, { modalName: 'isContactsModalVisible' }, {
    title: _withCtx(() => [
      _createTextVNode("Связаться с автором сайта")
    ]),
    body: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconDiscord)
            ]),
            _: 1
          }),
          _hoisted_4
        ]),
        _createElementVNode("p", _hoisted_5, [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconLetter)
            ]),
            _: 1
          }),
          _hoisted_6
        ])
      ]),
      _hoisted_7
    ]),
    _: 1
  }))
}